import { bl_fi_my_einvoice_from_irb_hdr_RowClass, bl_fi_my_einvoice_from_irb_line_RowClass } from '../../dbschema';
import { BaseContainerModel } from '../base-container.model';

export class MyEInvoiceFromIrbContainerContainerModel extends BaseContainerModel {
    bl_fi_my_einvoice_from_irb_hdr: bl_fi_my_einvoice_from_irb_hdr_RowClass = new bl_fi_my_einvoice_from_irb_hdr_RowClass();
    bl_fi_my_einvoice_from_irb_lines: bl_fi_my_einvoice_from_irb_line_RowClass[] = [];
}
